var map = {
	"./boulangerie.png": "9be1",
	"./desserts.png": "39a9",
	"./entrees.png": "a0fb",
	"./gateaux.png": "862e",
	"./logo.png": "cf05",
	"./plats.png": "fbf3",
	"./sauces.png": "fd09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";